var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2 Copy 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing---Web-Copy-6",
    transform: "translate(-1108.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-9",
    transform: "translate(1108.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-5",
    transform: "translate(100.000000, 100.000000) scale(-1, 1) translate(-100.000000, -100.000000) "
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.6956522,124.304348 C52.8149319,124.304348 64.2608696,112.85841 64.2608696,98.7391304 C64.2608696,84.6198507 52.8149319,73.173913 38.6956522,73.173913 C24.5763725,73.173913 13.1304348,84.6198507 13.1304348,98.7391304 C13.1304348,102.22714 13.1304348,112.372068 13.1304348,129.173913 L22.8695652,124.304348 C30.3883007,124.304348 35.663663,124.304348 38.6956522,124.304348 Z",
    id: "Oval",
    stroke: "#000000",
    transform: "translate(38.695652, 101.173913) rotate(-90.000000) translate(-38.695652, -101.173913) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9795491,106.109409 L82,87.5 L82,87.5 C78.6666667,82.6686199 77,79.0019533 77,76.5 C77,40.5 106.413536,23.9995838 127.5,23.9995838 C162.5,23.9995838 182,44 187.5,59 C193,74 190.058273,99.1200949 178,107 C164.232318,115.996979 179.628405,134.673468 169.5,137.5 C156.158142,141.223309 143.971536,152.888981 132.940183,172.497014 L132.940182,172.497013 C132.398586,173.45969 131.179133,173.801044 130.216456,173.259448 C129.747764,172.995764 129.405008,172.554441 129.265536,172.035067 C126.065104,160.117097 121.976592,151.772074 117,147 C108.538405,138.886142 91.5474225,153.82268 85.5,140 C83.1666667,134.666667 82,125.5 82,112.5 L72.3960132,107.46934 C71.9067819,107.213076 71.7179246,106.608733 71.9741886,106.119502 C71.9759562,106.116127 71.977743,106.112763 71.9795491,106.109409 Z",
    id: "Path-5",
    stroke: "#000000",
    strokeWidth: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.9483cb8c297a6fad162aee358448abc3.svg";
export { ForwardRef as ReactComponent };